var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isNotEmpty
    ? _c(
        "div",
        { staticClass: "details-panel details-panel__white my-0 py-0" },
        [
          _c("div", { staticClass: "details-panel__body " }, [
            _c("div", { staticClass: "row py-2" }, [
              _c("div", { staticClass: "col-8 col-md-8" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-md" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "custom-control custom-checkbox b-custom-control-lg",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.status,
                              expression: "status",
                            },
                          ],
                          staticClass: "custom-control-input",
                          attrs: {
                            type: "checkbox",
                            id: "leaseProlong_" + _vm.product,
                            value: "1",
                            name: "leaseProlongChecked[" + _vm.product + "]",
                          },
                          domProps: {
                            checked: Array.isArray(_vm.status)
                              ? _vm._i(_vm.status, "1") > -1
                              : _vm.status,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.addToCart(_vm.product)
                            },
                            change: function ($event) {
                              var $$a = _vm.status,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "1",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.status = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.status = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.status = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass:
                              "custom-control-label d-flex flex-wrap",
                            attrs: { for: "leaseProlong_" + _vm.product },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.products[_vm.product].name) +
                                " " +
                                _vm._s(
                                  _vm.getTranslation(
                                    "cart-vue",
                                    "lease_prolongation"
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-md" },
                    [
                      _vm.isTruss4Product(_vm.product)
                        ? [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.getPluralTranslation(
                                    "lease-prolong-vue",
                                    "licences_no_plural",
                                    _vm.$store.state.cart.leaseProlong[
                                      _vm.product
                                    ].info.length
                                  )
                                ) +
                                "\n                            (" +
                                _vm._s(
                                  _vm.products[_vm.product]
                                    .grace_lease_agreement.end_date
                                ) +
                                ")\n\n                        "
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isTruss4Product(_vm.product)
                        ? [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle",
                                    value:
                                      "leaseProlongCollapse_" + _vm.product,
                                    expression:
                                      "'leaseProlongCollapse_' + product",
                                  },
                                ],
                                staticClass:
                                  "btn-link--trigger d-inline-flex align-items-center mb-0",
                                attrs: { href: "javascript:;" },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.getTranslation(
                                        "single-upgrade-vue",
                                        "selected_programs"
                                      )
                                    ) +
                                    "\n                                "
                                ),
                                _c("span", { staticClass: "collapse-icon" }, [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "svg-inline--fa fa-caret-down fa-w-10 fa-2x",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 320 512",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          fill: "currentColor",
                                          d: "M287.968 160H32.038c-28.425 0-42.767 34.488-22.627 54.627l127.962 128c12.496 12.496 32.758 12.497 45.255 0l127.968-128C330.695 194.528 316.45 160 287.968 160zM160 320L32 192h256L160 320z",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-4 col-md-4" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 col-md text-right order-md-last" },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.priceFormat(_vm.leaseProlongPrice, true)) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-md text-right text-md-left" },
                    [
                      _vm.isTruss4Product(_vm.product)
                        ? [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.translateLeaseEnd(
                                    _vm.products[_vm.product]
                                      .grace_lease_agreement.months
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isTruss4Product(_vm.product)
                        ? [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.getTranslation(
                                    "front",
                                    "subscription_renewal_box_period_one_year"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            typeof _vm.programData != "undefined"
              ? _c(
                  "div",
                  [
                    _c(
                      "b-collapse",
                      {
                        staticClass: "row ",
                        attrs: { id: "leaseProlongCollapse_" + _vm.product },
                      },
                      _vm._l(_vm.existingKeys, function (key) {
                        return _vm.hasLicences(key.key_id)
                          ? _c(
                              "div",
                              { staticClass: "col-12 view-extras pl-5 mt-3" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-checkbox",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.keyStatus[key.key_id],
                                          expression: "keyStatus[key.key_id]",
                                        },
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        type: "checkbox",
                                        id:
                                          "toggle_lease_key" +
                                          _vm.product +
                                          "_" +
                                          key.key_id,
                                      },
                                      domProps: {
                                        value: 1,
                                        checked: Array.isArray(
                                          _vm.keyStatus[key.key_id]
                                        )
                                          ? _vm._i(
                                              _vm.keyStatus[key.key_id],
                                              1
                                            ) > -1
                                          : _vm.keyStatus[key.key_id],
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleKey(key.key_id)
                                        },
                                        change: function ($event) {
                                          var $$a = _vm.keyStatus[key.key_id],
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = 1,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.keyStatus,
                                                  key.key_id,
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.keyStatus,
                                                  key.key_id,
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.keyStatus,
                                              key.key_id,
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-control-label",
                                        attrs: {
                                          for:
                                            "toggle_lease_key" +
                                            _vm.product +
                                            "_" +
                                            key.key_id,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            #" +
                                            _vm._s(key.key_id) +
                                            " " +
                                            _vm._s(key.key_name) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.programData.info,
                                  function (program, index) {
                                    return program.key == key.key_id
                                      ? _c(
                                          "div",
                                          { staticClass: "col-12 view-extras" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "custom-control custom-checkbox",
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.programData.info[
                                                          index
                                                        ].selected,
                                                      expression:
                                                        "programData.info[index].selected",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "custom-control-input",
                                                  attrs: {
                                                    type: "checkbox",
                                                    id:
                                                      "lease_prolong_" +
                                                      _vm.product +
                                                      "_" +
                                                      index,
                                                    name:
                                                      "lease_prolong[" +
                                                      _vm.product +
                                                      "][" +
                                                      program.user_licence_id +
                                                      "]",
                                                  },
                                                  domProps: {
                                                    value: 1,
                                                    checked: Array.isArray(
                                                      _vm.programData.info[
                                                        index
                                                      ].selected
                                                    )
                                                      ? _vm._i(
                                                          _vm.programData.info[
                                                            index
                                                          ].selected,
                                                          1
                                                        ) > -1
                                                      : _vm.programData.info[
                                                          index
                                                        ].selected,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleLeaseProlongProgram(
                                                        _vm.product,
                                                        index
                                                      )
                                                    },
                                                    change: function ($event) {
                                                      var $$a =
                                                          _vm.programData.info[
                                                            index
                                                          ].selected,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = 1,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              _vm.programData
                                                                .info[index],
                                                              "selected",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              _vm.programData
                                                                .info[index],
                                                              "selected",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          _vm.programData.info[
                                                            index
                                                          ],
                                                          "selected",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "custom-control-label",
                                                    attrs: {
                                                      for:
                                                        "lease_prolong_" +
                                                        _vm.product +
                                                        "_" +
                                                        index,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                " +
                                                        _vm._s(program.name) +
                                                        " "
                                                    ),
                                                    program.quantity > 1
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "( " +
                                                              _vm._s(
                                                                program.quantity
                                                              ) +
                                                              " )"
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(
                                                      "\n                                " +
                                                        _vm._s(
                                                          program.version
                                                        ) +
                                                        "\n                                "
                                                    ),
                                                    program.discount > 0
                                                      ? [
                                                          _vm._v(
                                                            "\n                                    (" +
                                                              _vm._s(
                                                                program.discount
                                                              ) +
                                                              "% " +
                                                              _vm._s(
                                                                _vm.getTranslation(
                                                                  "lease-prolong-vue",
                                                                  "discount"
                                                                )
                                                              ) +
                                                              ")\n                                "
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.priceFormat(
                                                            _vm.getProgramPrice(
                                                              program.id,
                                                              "",
                                                              "cloud_time_quantity",
                                                              program.product,
                                                              program.quantity,
                                                              false,
                                                              program.discount
                                                            )
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e()
                                  }
                                ),
                              ],
                              2
                            )
                          : _vm._e()
                      }),
                      0
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }